import { MessageForm } from "./MessageForm";
import { SidebarToggleButton } from "./SidebarToggleButton";

const ASCII_LOGO = `
███████╗██╗  ██╗███████╗██████╗ ██╗      ██████╗  ██████╗
██╔════╝██║  ██║██╔════╝██╔══██╗██║     ██╔═══██╗██╔════╝
███████╗███████║█████╗  ██████╔╝██║     ██║   ██║██║  ███╗
╚════██║██╔══██║██╔══╝  ██╔══██╗██║     ██║   ██║██║   ██║
███████║██║  ██║███████╗██║  ██║███████╗╚██████╔╝╚██████╔╝
╚══════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝╚══════╝ ╚═════╝  ╚═════╝
`.trim();

export function WelcomeView(): React.JSX.Element {
  return (
    <div className="flex flex-1 flex-col">
      <div className="border-cyber-border border-b py-2 pr-2 pl-0 md:hidden">
        <div className="flex items-center px-2">
          <SidebarToggleButton />
        </div>
      </div>

      <div className="flex flex-1 flex-col items-center justify-center p-8">
        {/* Logo and tagline - narrower */}
        <div className="mb-6 max-w-md text-center">
          <pre className="text-glow-cyan text-cyber-cyan mb-4 text-[6px] leading-tight sm:text-[8px] md:text-xs">
            {ASCII_LOGO}
          </pre>
          <p className="text-cyber-muted text-sm">
            Bold's AI. Nose for trouble, tail always wagging.
          </p>
        </div>

        {/* Input - wider */}
        <div className="w-full max-w-2xl">
          <MessageForm autoFocus />
        </div>
      </div>
    </div>
  );
}
